export default function Footer() {
  return (
    <footer className="bg-[#0a0a0a] border-t border-[#1e1e1e] py-10">
      <div className="max-w-7xl mx-auto px-8 flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <img
            src="https://public.readdy.ai/ai/img_res/d418cd8b-a52c-4eae-9f4c-720bcf59e510.png"
            alt="BADI D.O.O."
            className="h-7 w-auto object-contain"
          />
          <span className="text-[#555] text-sm tracking-widest uppercase">BADI D.O.O.</span>
        </div>
        <p className="text-[#3a3a3a] text-xs text-center">
          &copy; {new Date().getFullYear()} BADI D.O.O. All rights reserved. iOS Application Development.
        </p>
        <p className="text-[#3a3a3a] text-xs">North Macedonia</p>
      </div>
    </footer>
  );
}
